import React from 'react';
import './HeroSection.css';

const HeroSection = () => {
  return (
    <section className="hero-section">
      <div className="hero-overlay"></div>
      <div className="hero-content">
        <h1 className="hero-title">Nand</h1>
        <p className="hero-description">
          Empowering your business with seamless wholesale solutions.
        </p>
        <div className="hero-highlights">
          <span className="highlight-item">Fast Delivery</span>
          <span className="highlight-item">Competitive Pricing</span>
        </div>
        <a href="#quote" className="hero-cta">Get Started</a>
      </div>
    </section>
  );
};

export default HeroSection;